/**
 * Centralised localStorage keys + one-time migration:
 *  - legacy "ricezione_*" / "advena_*" → "xenia_*"
 *  - drop the JWT from localStorage (now stored only as httpOnly cookie)
 * Run this module once at app bootstrap (imported in index.js).
 */
import { logDev } from "./logger";

export const STORAGE_KEYS = {
  // NOTE: `token` key is intentionally kept exported only as a constant for
  // legacy-cleanup; we MUST NOT write to it any more — JWT is httpOnly cookie.
  token: "xenia_token",
  user: "xenia_user",
  propertyId: "xenia_property_id",
  language: "xenia_lang",
};

const LEGACY_MAP = {
  ricezione_token: STORAGE_KEYS.token,
  ricezione_user: STORAGE_KEYS.user,
  ricezione_property_id: STORAGE_KEYS.propertyId,
  ricezione_lang: STORAGE_KEYS.language,
  advena_token: STORAGE_KEYS.token,
  advena_user: STORAGE_KEYS.user,
  advena_property_id: STORAGE_KEYS.propertyId,
  advena_lang: STORAGE_KEYS.language,
};

export function migrateLegacyStorage() {
  try {
    for (const [oldKey, newKey] of Object.entries(LEGACY_MAP)) {
      const v = localStorage.getItem(oldKey);
      if (v != null) {
        if (localStorage.getItem(newKey) == null) {
          localStorage.setItem(newKey, v);
        }
        localStorage.removeItem(oldKey);
      }
    }
    // Security migration: remove any pre-existing JWT from localStorage.
    // Auth now relies exclusively on httpOnly cookies (XSS-safe).
    if (localStorage.getItem(STORAGE_KEYS.token) != null) {
      localStorage.removeItem(STORAGE_KEYS.token);
    }
  } catch (err) {
    // localStorage may be disabled (private browsing mode); never break the app.
    logDev("storage migrateLegacyStorage", err);
  }
}
